import { Phone } from "lucide-react";
import { trackCall } from "@/lib/track";

export const Header = () => (
  <header className="site-header" data-testid="site-header">
    <div className="wrap site-header-inner">
      <div className="brand">
        <img src="/assets/logo.png" alt="DIY Tek Systems logo: a hex head tek screw over the company name" width="62" height="62" />
        <div>
          <div className="brand-name">DIY Tek Systems, LLC</div>
          <div className="brand-loc">Midland, Texas</div>
        </div>
      </div>
      <a className="btn btn-primary header-phone" href="tel:+18666526569" onClick={() => trackCall("header")} data-testid="header-phone-btn">
        <Phone size={16} aria-hidden="true" />
        866-652-6569
      </a>
    </div>
  </header>
);
